export function CategoryEmptyState() {
  return (
    <section className="overflow-hidden rounded-[1.9rem] border border-[#d8e4d4] bg-white shadow-[0_22px_52px_-38px_rgba(0,39,0,0.28)]">
      <div className="px-6 py-7 sm:px-8 sm:py-8">
        <p className="text-xs font-semibold uppercase tracking-[0.22em] storefront-text-muted">
          Menu update
        </p>
        <h2 className="mt-3 text-[1.6rem] font-semibold tracking-tight storefront-text-heading">
          No dishes are live in this category yet
        </h2>
        <p className="mt-3 max-w-2xl text-[0.98rem] leading-7 storefront-text-body">
          This section will fill out automatically as soon as the dishes are
          available in Umbraco.
        </p>
      </div>
    </section>
  );
}
